<template>
    <div class="container">

        <header class="container__header">

            <div class="settings">

                <h1 v-if="isCreating">Tilføj nyt sted</h1>
                <h1 v-else>Rediger sted</h1>

                <ws-dropdown v-if="!isCreating">

                    <template slot="thumb">	<i class="fas fa-cog icon--sm dark-grey"></i></template>

                    <template slot="content">

                        <ul>
                            <li><a href="#" @click.prevent="doShowDeleteModal"><i class="fas fa-trash-alt"></i> Slet</a></li>
                        </ul>

                    </template>

                </ws-dropdown>

            </div>
        </header>

        <div class="container__body container__body--xsm">

            <form class="col-12" @submit.prevent="submitPoint">

                <div class="col-12 margin-b-75">

                    <label>Stedets navn</label>

                    <input class="col-12" type="text" name="name" placeholder="Hvad er stedets navn?" minlength="2" maxlength="120" required v-model="point.name">

                </div>

                <div class="col-12 margin-b-75">

                    <label>Stedets adresse</label>

                    <input class="col-12" type="text" name="address" placeholder="Hvad er stedets adresse?" minlength="4" maxlength="120" required v-model="point.address">

                </div>

                <div class="col-12 margin-b-75">

                    <label>Stedets postnummer</label>

                    <input class="col-12" type="text" name="zipcode" placeholder="Hvad er stedets postnummer?" minlength="4" maxlength="4" required v-model="point.zipcode">

                </div>

                <div class="col-12 margin-b-75">

                    <label>Stedets by</label>

                    <input class="col-12" type="text" name="city" placeholder="Hvad er stedets by?" minlength="2" maxlength="120" required v-model="point.city">

                </div>


                <div class="col-12 margin-t-75">

                    <button type="submit" class="btn btn--md btn--primary primary--copper" :disabled="!validateForm || isSaving">

                        <span v-if="isSaving"><i class="spinner--light"></i> Gemmer</span>

                        <span v-else>Gem sted</span>

                    </button>

                </div>

            </form>

        </div>

        <ws-modal v-model="showDeleteModal">

            <div class="modal-wrap">

                <div class="modal--sm center">

                    <span class="close" @click.prevent="showDeleteModal = false"><i class="fas fa-times"></i></span>

                    <i class="fas fa-trash-alt icon--lg margin-b-25"></i>

                    <h1>Slet Udleveringssted?</h1>

                    <h2>Er du sikker på du vil slette {{point.name}}?</h2>

                    <h3>Du kan ikke fortryde denne handling!</h3>

                    <div class="col-12 margin-t-25">

                        <a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="deleteDeliveryPoint">Ja tak</a>

                        <a href="#" @click.prevent="showDeleteModal = false">Nej tak!</a>

                    </div>

                </div>

            </div>

        </ws-modal>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        name: "create-delivery-point",
        data(){
            return {
                point: {
                    name: '',
                    address: '',
                    zipcode: '',
                    city: '',
                },
                isSaving:false,
                showDeleteModal:false,
            };
        },
        computed:{
            isCreating() {
                return !this.$route.params.hasOwnProperty('point');
            },
            validateName(){
                return this.point.name !== '' && String(this.point.name).length > 0;
            },
            validateAddress(){
                if (this.point.address) {
                    var addressRegex = this.point.address.match(/([A-Z])\w*\s+([0-9])+/gi);

                    return this.point.address !== '' && (addressRegex instanceof Array && addressRegex.length > 0);
                }

                return false;
            },
            validateZip(){
                if (this.point.zipcode && String(this.point.zipcode).length === 4) {

                    var zipcodeRegex = String(this.point.zipcode).match(/^([0-9]){4,4}/gi);

                    return this.point.zipcode !== '' && (zipcodeRegex instanceof Array && zipcodeRegex.length > 0 && zipcodeRegex.length < 5);
                }

                return false;
            },
            validateCity(){
                return this.point.city !== '' && String(this.point.city).length > 0;
            },
            validateForm(){
                return this.validateName
                    && this.validateAddress
                    && this.validateZip
                    && this.validateCity;
            }
        },
        methods:{
            submitPoint(){
                if(!this.validateForm){
                    return;
                }

                if(this.isCreating){
                    return this.createPoint();
                }
                this.updatePoint();
            },

            createPoint(){
                this.isSaving = true;

                axios.post(`/api/admin/delivery/points`, this.point).then(response => {
                    this.$router.replace({
                        name:'deliveryPoint.index',
                    });
                    this.isSaving = false;
                });
            },
            updatePoint(){
                this.isSaving = true;

                axios.put(`/api/admin/delivery/points/${this.$route.params.point}`, this.point).then(response => {
                    this.$router.replace({
                        name:'deliveryPoint.index',
                    });
                    this.isSaving = false;
                });
            },
            doShowDeleteModal(){
                this.showDeleteModal = true;
            },
            deleteDeliveryPoint(){
                axios.delete(`/api/admin/delivery/points/${this.$route.params.point}`).then(()=>{
                    this.$router.replace({
                        name:'deliveryPoint.index',
                    })
                });
            },
        },
        created() {
            if(!this.isCreating){
                axios.get(`/api/admin/delivery/points/${this.$route.params.point}`).then(response => {
                    this.point = response.data.data;
                });
            }
        }
    }
</script>

<style scoped>

</style>
